export enum ComponentRoutesEnum {
	MARKETING = 'marketing',
	EMAIL_OTP = 'emailotp',
	BUSINESS_DESCRIPTION = 'business-description',
	BUSINESS_TYPE = 'business-type',
	BUSINESS_ACTIVITY = 'business-activity',
	FATCA = 'fatca',
	INCOME_DETAILS = 'income-details',
	TAX_DETAILS = 'tax-details',
	CONTACT_OWNERSHIP = 'contact-ownership',
	CONTACT_DETAILS = 'contact-details',
	OWNERSHIP_STRUCTURE = 'ownership-structure',
	ADD_EDIT_DIRECTOR_SHAREHOLDER = 'add-edit-shareholder-director',
	REVIEW = 'review',
	CRA = 'cra',
	GENERIC_ERROR_PAGE = 'generic-error',
	QUEBEC_RESTRICTION = 'quebec-restriction',
	NEW_SBB_USER_ERROR = 'new-sbb-user-error',
	AGE_RESTRICTION_DIRECTOR = 'age-restriction-director',
	AGE_RESTRICTION_BANKING = 'age-restriction-banking',
	MAX_ACCOUNTS_ERROR = 'max-accounts-error',
	OWNERSHIP_RESTRICTION = 'ownership-restriction',
	SOMETHING_WENT_WRONG = 'something-went-wrong',
	TECHNICAL_DIFFICULTIES = 'technical-difficulties',
	COMPLETE = 'complete',
	VERIFICATION_GATED = 'verification-gated',
	LOADING_CUSTOMER = 'loading-customer',
	LOGIN = 'login',
	MAXIMUM_CUSTOMER_LIMIT_REACHED = 'maximum-customer-limit',
	INVALID_URL = 'invalid-url',
	HAND_BREAK = 'user-restriction'
}
